import { LuIcon, Menu, type MenuGroupProps } from "@overmap-ai/blocks"
import type { IdentifierModel, UUID } from "@overmap-ai/common"

import { modelIconMapping } from "../../mappings/icons"
import { genericMemo } from "../../utils/optimization"

export interface IdentifierGroupProps<TIdentifier extends UUID<IdentifierModel>> extends MenuGroupProps {
	identifiers: TIdentifier[]
	onIdentifierSelect: (identifier: TIdentifier) => void
}

export const IdentifierGroup = genericMemo(function <TIdentifier extends UUID<IdentifierModel>>(
	props: IdentifierGroupProps<TIdentifier>,
) {
	const { ref, identifiers, onIdentifierSelect, ...rest } = props

	return (
		<Menu.Group ref={ref} {...rest}>
			{identifiers.map((identifier) => (
				<Menu.Item key={identifier.uuid} onSelect={() => onIdentifierSelect(identifier)} className="truncate">
					<LuIcon icon={modelIconMapping.identifier} />
					<span className="truncate">{identifier.name}</span>
				</Menu.Item>
			))}
		</Menu.Group>
	)
})
